export interface TimeOption {
  value: string; // "06:00", "06:30", etc. (24h for storage)
  label: string; // "6:00AM", "6:30AM", etc. (12h for display)
}

export const minutesOfDay = (value: string) => {
  const [hour, minute] = value.split(':').map(Number);
  return hour * 60 + minute;
};

export function toTimeLabel(value: string): string {
  const [hour, minute] = value.split(':').map(Number);
  const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;
  return `${displayHour}:${String(minute).padStart(2, '0')}${hour < 12 ? 'AM' : 'PM'}`;
}

// Hardcoded for now; will be replaced by backend time config API later
function generateTimeOptions({
  startHour = 0,
  endHourExclusive = 24,
  stepMinutes = 15,
}: { startHour?: number; endHourExclusive?: number; stepMinutes?: number } = {}): TimeOption[] {
  const options: TimeOption[] = [];
  for (let hour = startHour; hour < endHourExclusive; hour++) {
    for (let minute = 0; minute < 60; minute += stepMinutes) {
      const value = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;
      options.push({ value, label: toTimeLabel(value) });
    }
  }
  return options;
}

export const FULL_DAY_TIME_OPTIONS = generateTimeOptions();
